var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessages(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8708",
    "data-name": "Group 8708",
    transform: "translate(-975 -30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    transform: "translate(975 30)",
    fill: "rgba(255,255,255,0)",
    stroke: "#dadce0",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-chatbubbles",
    "data-name": "Icon ionic-ios-chatbubbles",
    transform: "translate(981.625 36.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12085",
    "data-name": "Path 12085",
    d: "M22.74,15.989a1.121,1.121,0,0,1,.153-.565,1.557,1.557,0,0,1,.1-.143A7.5,7.5,0,0,0,24.267,11.1a7.872,7.872,0,0,0-8.038-7.728,7.982,7.982,0,0,0-7.88,6.15,7.436,7.436,0,0,0-.171,1.583,7.85,7.85,0,0,0,7.913,7.825,9.53,9.53,0,0,0,2.184-.356c.523-.143,1.041-.333,1.175-.384a1.223,1.223,0,0,1,.43-.079,1.2,1.2,0,0,1,.467.093l2.624.93a.626.626,0,0,0,.18.046.368.368,0,0,0,.37-.37.594.594,0,0,0-.023-.125Z",
    transform: "translate(-0.892 0)",
    fill: "#0086e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12086",
    "data-name": "Path 12086",
    d: "M15.892,22.574c-.167.046-.379.1-.611.148a8.541,8.541,0,0,1-1.573.208A7.85,7.85,0,0,1,5.8,15.1a8.749,8.749,0,0,1,.069-.99c.028-.2.06-.4.106-.592s.1-.416.162-.62l-.37.329a6.886,6.886,0,0,0-2.388,5.178A6.81,6.81,0,0,0,4.523,22.2c.106.162.167.287.148.37s-.551,2.869-.551,2.869a.371.371,0,0,0,.125.356.377.377,0,0,0,.236.083.332.332,0,0,0,.134-.028l2.6-1.023a.723.723,0,0,1,.555.009,7.788,7.788,0,0,0,2.809.555,7.268,7.268,0,0,0,5.558-2.55s.148-.2.319-.444C16.281,22.463,16.086,22.523,15.892,22.574Z",
    transform: "translate(0 -2.507)",
    fill: "#0086e6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.b99ea011de5138225f08680528218700.svg";
export { ForwardRef as ReactComponent };